import React, { useEffect, useState } from 'react';
import { Container, WarningMessage, Logo, DownloadButtonContainer } from "./style";
import { appStoreImage, blackLogo, androidStoreImage } from '../../../utils/staticImages';
import { axiosInstance } from '../../../utils/axiosInstance';
import { API_ENDPOINTS } from '../../../utils/constants';

interface Props {
	queryString: string;
}

const Index: React.FC<Props> = ({ queryString }) => {
	const [message, setMessage] = useState("")
	const fetchData = async () => {
		const headers = {
			"X-Api-Key": "yLnaRQj9hycxEyQEX4cVOPrfxAg5bZAx7jYI+jJc/dE=",
		};

		const options = {
			headers: headers,
		};
		const response = await axiosInstance.get(`${API_ENDPOINTS.LOCALIZATION}?key=${queryString}`, options);
		setMessage(response?.data?.result[0]?.label ?? "")
	};

	useEffect(() => {
		fetchData();
	}, []);

	return (
		<Container>
			<Logo src={blackLogo} alt="Logo" />
			<WarningMessage>{message}</WarningMessage>
			<DownloadButtonContainer>
				<a href="https://apps.apple.com/tr/app/i-%C3%A7inde-ko%C3%A7-var/id1666252893">
					<img src={appStoreImage} alt="App Store" />
				</a>
				<a href="https://play.google.com/store/apps/details?id=com.koc.icindekocvar">
					<img src={androidStoreImage} alt="Google Play" />
				</a>
			</DownloadButtonContainer>
		</Container>
	);
};

export default Index;